import { Record } from "immutable";

import { UserModel } from "./UserModel";

const defaults = {
  createdAt: new Date(0),
  creator: null as null | UserModel,
  expiresAt: null as Date | null,
  id: "",
  lastUsedAt: null as Date | null,
  name: "",
  user: new UserModel(),
};

export class UserPersonalAccessTokenModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { createdAt, expiresAt, id, lastUsedAt, name, user } = data as typeof defaults;
    const userModel = UserModel.fromServerData(user);
    return new UserPersonalAccessTokenModel({
      createdAt: new Date(createdAt),
      creator: userModel,
      expiresAt: expiresAt ? new Date(expiresAt) : null,
      id,
      lastUsedAt: lastUsedAt ? new Date(lastUsedAt) : null,
      name,
      user: userModel,
    });
  }
}
